module.exports = __webpack_public_path__ + "static/media/wave.4bab3cc1.svg";